module.exports = __webpack_public_path__ + "img/icon_kszxvipslt.1de8e747.png";